export default __webpack_public_path__ + "assets/images/1536b3d3421a8528bcd35d4358fd16c2.jpg";